var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 35.5C46 30.2533 50.2533 26 55.5 26C60.7467 26 65 30.2533 65 35.5C65 40.7467 60.7467 45 55.5 45C50.2533 45 46 40.7467 46 35.5ZM55.5 17C45.2827 17 37 25.2827 37 35.5C37 45.7173 45.2827 54 55.5 54C65.7173 54 74 45.7173 74 35.5C74 25.2827 65.7173 17 55.5 17ZM32 87.5C32 74.5213 42.5213 64 55.5 64C68.4787 64 79 74.5213 79 87.5C79 89.9853 81.0147 92 83.5 92C85.9853 92 88 89.9853 88 87.5C88 69.5507 73.4493 55 55.5 55C37.5507 55 23 69.5507 23 87.5C23 89.9853 25.0147 92 27.5 92C29.9853 92 32 89.9853 32 87.5Z",
    fill: "#808080"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.645d05a066215f55526035a838338db5.svg";
export { ForwardRef as ReactComponent };